import { Button, Col, Form, Input, Row, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { SelectAnimalType } from '../../../components/selects';
import { SearchOutlined } from '@ant-design/icons';

interface IProps {
  formField: any;
  form: any;
  onReset: () => void;
  onSearch: () => void;
}

export const FilterPopulations = (props: IProps) => {
  const { t } = useTranslation();

  return (
	<Form form={ props.form } layout='vertical'>
	  <Row gutter={ 10 }>
		<Col span={ 6 }>
		  <Form.Item
			label={ t('population.animal_type_population') }
			name={ props.formField.animalTypeIds }
		  >
			<SelectAnimalType/>
		  </Form.Item>
		</Col>
		<Col span={ 6 }>
		  <Space.Compact>
			<Form.Item
			  label={ t("population.population_from") }
			  name={ props.formField.countFrom }
			>
			  <Input type='text'/>
			</Form.Item>

			<Form.Item
			  label={ t("population.population_up_to") }
			  name={ props.formField.countTo }
			>
			  <Input type='text'/>
			</Form.Item>

		  </Space.Compact>

		</Col>

		<Col span={ 6 }>
		  <div style={ { marginTop: 30 } }>
			<Button
			  type="primary"
			  shape="default"
			  size="middle"
			  icon={ <SearchOutlined/> }
			  style={ { marginRight: 'auto' } }
			  onClick={ props.onSearch }
			>{ t('general.search') }</Button>
			<Button
			  size="small"
			  type="link"
			  onClick={ props.onReset }
			  style={ { color: "orange" } }
			>{ t('general.reset') }</Button>
		  </div>
		</Col>
	  </Row>

	</Form>
  )
}
